import { call, put, takeLatest } from "redux-saga/effects";
import { fetchInvoiceAPI } from "../../services/invoice/invoice.api";
import { type SagaIterator } from "@redux-saga/core";
import { InvoiceActions } from "./slice";
import { showSnackbar } from "../snackbar/slice";
import { withLoader } from "../loader/saga";

interface InvoiceAction {
  type: string;
  payload: { orderId: string };
}

function* fetchInvoiceWorker(action: InvoiceAction): SagaIterator {
  try {
    const result = yield* withLoader(function* () {
      return yield call(fetchInvoiceAPI, action.payload.orderId);
    });
    const message = result?.message;
    const fileBase64Content = result?.data?.fileBase64Content;

    if (!result?.data) {
      yield put(InvoiceActions.fetchInvoiceFailure(message));
      yield put(showSnackbar({ message, severity: "info" }));
      return;
    }
    if (fileBase64Content) {
      yield put(InvoiceActions.fetchInvoiceSuccess(result.data));
    }
  } catch (error: any) {
    yield put(
      InvoiceActions.fetchInvoiceFailure(error.message || "Unknown error")
    );
  }
}

export function* invoiceWatcherSaga(): SagaIterator {
  yield takeLatest(InvoiceActions.fetchAll.type, fetchInvoiceWorker);
}
